import { render, staticRenderFns } from "./step2-selectMajor.vue?vue&type=template&id=f5b57322&scoped=true"
import script from "./step2-selectMajor.vue?vue&type=script&lang=js"
export * from "./step2-selectMajor.vue?vue&type=script&lang=js"
import style0 from "./step2-selectMajor.vue?vue&type=style&index=0&id=f5b57322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b57322",
  null
  
)

export default component.exports